import { styled } from "@mui/material";

export const IconWrapper = styled("div")`
  width: 16px;
  height: 16px;
`;
